import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ColumnChooser from '../../../../components/ColumnChooser';
import { ColumnChooserModel } from '../../../../models/common/ColumnChooserModel';
import { GetYurticiCargoAgreementListPagingAndFilterRequest } from '../../../../models/request/yurticiCargoAgreement/GetYurticiCargoAgreementListPagingAndFilterRequest';
import { RootState } from '../../../../redux/store';
import { MenuComponent } from '../../../../_metronic/assets/ts/components';
import ExcelExportMenu from '../../../../components/ExcelExportMenu';
import { ExcelExportMode } from '../../../../helpers/excelExportRequest';
import TableConstantActions from '../../../../components/TableConstantActions';

interface Props {
    columns: ColumnChooserModel[]
    setColumns: React.Dispatch<React.SetStateAction<ColumnChooserModel[]>>
    getColumns: () => ColumnChooserModel[]
    pageName: string
    pageVersion: string
    excelExport: (mode: ExcelExportMode) => void
    filter: GetYurticiCargoAgreementListPagingAndFilterRequest
    getData: (_filter?: GetYurticiCargoAgreementListPagingAndFilterRequest | undefined) => Promise<void>
    setFilter: React.Dispatch<React.SetStateAction<GetYurticiCargoAgreementListPagingAndFilterRequest>>
    selectedCount: number
    deleteFunction: () => void
    updateFunction: () => void
    onSearchSubmit: (e: any) => void
}

const YurticiCargoAgreementListFilters = ({
    columns,
    setColumns,
    getColumns,
    pageName,
    pageVersion,
    excelExport,
    filter,
    getData,
    setFilter,
    selectedCount,
    deleteFunction,
    onSearchSubmit,
    updateFunction
}: Props) => {
    const navigate = useNavigate();
    const auth = useSelector((state: RootState) => state.auth)

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)
    }, [])

    return (
        <React.Fragment>
            <TableConstantActions
                deleteFunction={deleteFunction}
                onSearchSubmit={onSearchSubmit}
                pageName={pageName}
                hideSearch={true}
                searchTerm={filter.searchTerm}
                selectedCount={selectedCount}
                setSearchTerm={(e) => setFilter({ ...filter, searchTerm: e })}
                updateFunction={updateFunction}
            />

            <ColumnChooser
                columns={columns}
                getColumns={getColumns}
                pageName={pageName}
                pageVersion={pageVersion}
                setColumns={setColumns}
            />

            <ExcelExportMenu
                pageName={pageName}
                selectedCount={selectedCount}
                onExport={excelExport}
            />

            {/* Filtreler paneli kaldırıldı (22.09.2026): Şablon kolon başlığının
                altındaki filtrede var. */}

            <React.Fragment>
                {
                    auth.user.user?.data.authorizedMenus.find(x => x.menuName == pageName)?.canInsert && (
                        <div className='m-0'>
                            <a
                                onClick={() => navigate('/yurticicargoagreement/listadd')}
                                className='btn btn-sm fw-bold btn-primary'
                            >
                                Yeni Anlaşma Ekle
                            </a>
                        </div>
                    )
                }
            </React.Fragment>
        </React.Fragment>
    )
}

export default YurticiCargoAgreementListFilters;